export default __webpack_public_path__ + "static/media/sun.d3ad7c20.png";